module.exports = __webpack_public_path__ + "static/p08_cerdoGrandeTop-a0d91105cd0c698e625674932bed3763.png";